var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"account"}},[_c('h1',[_vm._v("Mon compte")]),_c('div',{staticClass:"ui stackable grid"},[_c('div',{staticClass:"five wide column"},[_c('UserProfile'),_c('UserActivity')],1),_c('div',{staticClass:"eleven wide column"},[_c('UserProjectsList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }